import { useContext } from 'react';
import { ShellContext } from '../../contexts/shellContext';
import { AppPropsType } from '../../App/types';

const useShellContext = (): Partial<AppPropsType> => {
  const context = useContext(ShellContext);
  return {
    ...context,
    authProvider: context?.authProvider
      ? context.authProvider
      : window?.Shell?.v1?.authProvider
  };
};
export default useShellContext;
